import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import StandardDropdown from '@wix/da-shared-react/pkg/Dropdown2/Preset/StandardDropdown';
import { PostsSortOrder } from '../../../../../../types/posts';

interface Props {
  value: PostsSortOrder;
  onChange: (value: PostsSortOrder) => void;
  className?: string;
}

class SortOrderSwitcher extends React.Component<Props & WithTranslation> {
  render() {
    const { t, value, onChange, className } = this.props;
    const items = this.getOptions();
    return (
      <StandardDropdown
        className={className}
        menuLabel={t('common.sortOrder')}
        menuAlignment="left"
        selectedValue={value}
        onSelect={onChange}
        items={items}
      />
    );
  }

  getOptions = () => {
    const { t } = this.props;
    return [
      { value: PostsSortOrder.NEWEST, label: t!('common.sortOrder.newest') },
      { value: PostsSortOrder.OLDEST, label: t!('common.sortOrder.oldest') },
    ];
  };
}

export default withTranslation()(SortOrderSwitcher);
